import * as React from "react";
import {List} from 'immutable'
import * as Errors from "../validation_error";
import { ValidationError } from "../../types/types";


export const SimpleFormInput = (
  props: {
    errors: List<ValidationError>
    path: string
    className?: string
    children:JSX.Element
  }
) => {
  let errorClass =
    Errors.hasPath(props.errors, props.path) ? "field_with_errors" : "";
  return (
    <div
      className={`${props.className} ${errorClass}`}>
      {props.children}
      {Errors.hasPath(props.errors, props.path) ?
        <span className="error">
          {Errors.forPath(props.errors, props.path).message}
        </span>
      : null }
    </div>
  )
}
